import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import store from "./store";
import reportWebVitals from "./reportWebVitals";
import "./index.css";

// Suppress MetaMask connection errors if not using Web3 features
window.addEventListener('error', (event) => {
  if (event.message && event.message.includes('MetaMask')) {
    event.preventDefault();
    console.warn('MetaMask error suppressed:', event.message);
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && event.reason.message.includes('MetaMask')) {
    event.preventDefault();
    console.warn('MetaMask promise rejection suppressed:', event.reason.message);
  }
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
